import { render, staticRenderFns } from "./ImportList.vue?vue&type=template&id=0d4ce7a8&"
import script from "./ImportList.vue?vue&type=script&lang=js&"
export * from "./ImportList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports